/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-10-12 14:30:54
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-10-14 11:42:49
 * @FilePath: \crm-product\found\views\mdm\views\dealer_address\form\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Form from '../../../../../components/form';
import request from '../../../../../utils/request';
import Dealer from '../components/dealer.vue';

formCreate.component('Dealer', Dealer);

export default {
  extends: Form,
  components: {},
  data() {
    return {
      formFunctionCode: 'main-form',
      formParentCode: 'CRM20261009000000002',
    };
  },
  methods: {
    setRule(item) {
      const v = item;
      // 经销商：输入框点击弹窗选择
      if (v.field === 'customerCode') {
        v.props = {
          ...v.props,
          title: v.title,
          params: {
            functionCode: 'choose-dealer-list',
            parentCode: 'CRM20261009000000002',
            paramData: {
              enableStatus: '009',
              actApproveStatus: '3',
              customerType: 'dealer',
              supplyPosCode: JSON.parse(localStorage.getItem('userInfo')).positionCode,
            },
          },
          getValue: (field) => this.getFieldValue(field),
        };
        v.on = {
          ...v.on,
          change: (val) => this.setDealer(val),
        };
      }
      // 省
      if (v.field === 'provinceCode') {
        v.restful = '/mdm/mdmRegionController/select';
        v.optionsKey = {
          label: 'regionName',
          value: 'regionCode',
        };
        v.restfulParams = {
          regionLevel: '1',
        };
        v.props = {
          ...v.props,
          filterable: true,
          // 新增时未选经销商前禁用（编辑/查看回显不受影响）
          disabled: this.formConfig.code !== 'edit' && this.formConfig.code !== 'view',
        };
        v.on = {
          ...v.on,
          // 切换省时清空市、区并控制可选状态；选中时从选项带出省名称
          change: (val) => {
            const rule = this.getRule('provinceCode');
            const selected = (rule.options || []).find((option) => option.value === val) || {};
            this.setValue({
              provinceName: selected.regionName || '',
              cityCode: '',
              cityName: '',
              districtCode: '',
              districtName: '',
            });
            this.updateRules({
              cityCode: {
                props: {
                  disabled: !val,
                },
              },
              districtCode: {
                props: {
                  disabled: true,
                },
              },
            });
          },
        };
      }
      // 市
      if (v.field === 'cityCode') {
        v.restful = '/mdm/mdmRegionController/select';
        v.optionsKey = {
          label: 'regionName',
          value: 'regionCode',
        };
        v.restfulParamsGetValue = {
          parentCode: 'provinceCode',
        };
        v.refresh = true;
        v.props = {
          ...v.props,
          filterable: true,
          // 新增时未选省前禁用（编辑/查看回显不受影响）
          disabled: this.formConfig.code !== 'edit' && this.formConfig.code !== 'view',
        };
        v.on = {
          ...v.on,
          // 切换市时清空区并控制可选状态；选中时从选项带出市名称
          change: (val) => {
            const rule = this.getRule('cityCode');
            const selected = (rule.options || []).find((option) => option.value === val) || {};
            this.setValue({
              cityName: selected.regionName || '',
              districtCode: '',
              districtName: '',
            });
            this.updateRules({
              districtCode: {
                props: {
                  disabled: !val,
                },
              },
            });
          },
        };
      }
      // 区
      if (v.field === 'districtCode') {
        v.restful = '/mdm/mdmRegionController/select';
        v.optionsKey = {
          label: 'regionName',
          value: 'regionCode',
        };
        v.restfulParamsGetValue = {
          parentCode: 'cityCode',
        };
        v.refresh = true;
        v.props = {
          ...v.props,
          filterable: true,
          // 新增时未选市前禁用（编辑/查看回显不受影响）
          disabled: this.formConfig.code !== 'edit' && this.formConfig.code !== 'view',
        };
        v.on = {
          ...v.on,
          // 选中时从选项带出区名称
          change: (val) => {
            const rule = this.getRule('districtCode');
            const selected = (rule.options || []).find((option) => option.value === val) || {};
            this.setValue({
              districtName: selected.regionName || '',
            });
          },
        };
      }

      // 单据类型：控制原地址显示隐藏
      if (v.field === 'type') {
        v.on = {
          ...v.on,
          change: (val) => this.setType(val),
        };
      }
      // 原地址：根据经销商带出可选地址
      if (v.field === 'oldAddress') {
        v.restful = '/mdm/mdmCustomerAddressController/list';
        v.optionsKey = {
          label: 'detailedAddress',
          value: 'id',
        };
        v.restfulParams = {
          pageNum: 1,
          pageSize: 100,
        };
        v.restfulParamsGetValue = {
          customerCode: 'customerCode',
        };
        v.refresh = true;
        v.props = {
          ...v.props,
          filterable: true,
          // 新增时未选经销商前禁用（编辑/查看回显不受影响）
          disabled: this.formConfig.code !== 'edit' && this.formConfig.code !== 'view',
        };
        v.on = {
          ...v.on,
          // 选项加载完成后拼接省市区展示全地址
          optionCallback: (optionList) => {
            (optionList || []).forEach((option) => {
              const row = option;
              row.label = `${row.provinceName || ''}${row.cityName || ''}${row.districtName || ''}${row.detailedAddress || ''}`;
            });
          },
          // 选中后带出originalId、原联系人、原联系人电话（仅展示原信息，不写入现联系人）
          change: (val) => {
            const rule = this.getRule('oldAddress');
            const row = (rule.options || []).find((option) => option.id === val) || {};
            this.setValue({
              originalId: row.id || val || '',
              oldContactName: row.contactName || '',
              oldContactPhone: row.contactPhone || '',
            });
          },
        };
      }

      // 手机号格式校验（提交时同样会校验）
      if (v.field === 'contactPhone') {
        v.validate = [
          ...v.validate,
          {
            trigger: 'blur',
            pattern: /^1[3456789]\d{9}$/,
            message: '请输入正确手机号',
          },
        ];
      }

      return v;
    },
    // 经销商弹窗选择回调：带入编码、名称，并联动省市区、原地址可选状态
    setDealer(val) {
      const row = (Array.isArray(val) ? val[0] : val) || {};
      const hasDealer = !!row.customerCode;
      this.setValue({
        customerCode: row.customerCode || '',
        customerName: row.customerName || '',
        // 切换/清空经销商后原地址、原联系人需重新选择
        oldAddress: '',
        originalId: '',
        oldContactName: '',
        oldContactPhone: '',
      });
      // 经销商带出收货人、手机号（行数据有值才覆盖，避免清空手动输入）
      if (row.concatName || row.concatPhone) {
        this.setValue({
          contactName: row.concatName || '',
          contactPhone: row.concatPhone || '',
        });
      }
      if (!hasDealer) {
        // 清空经销商时联动清空省市区
        this.setValue({
          provinceCode: '',
          provinceName: '',
          cityCode: '',
          cityName: '',
          districtCode: '',
          districtName: '',
        });
      }
      // 未选经销商前省市区、原地址不可选
      this.updateRules({
        provinceCode: {
          props: {
            disabled: !hasDealer,
          },
        },
        cityCode: {
          props: {
            disabled: !hasDealer || !this.getFieldValue('provinceCode'),
          },
        },
        districtCode: {
          props: {
            disabled: !hasDealer || !this.getFieldValue('cityCode'),
          },
        },
        oldAddress: {
          props: {
            disabled: !hasDealer,
          },
        },
      });
    },
    // 单据类型切换：修改已有地址展示原联系人信息、原地址，新增地址隐藏
    setType(val) {
      const show = String(val) === '1';
      this.hiddenFields(!show, ['h1', 'oldAddress', 'oldContactName', 'oldContactPhone']);
      if (!show) {
        this.setValue({
          oldAddress: '',
          originalId: '',
          oldContactName: '',
          oldContactPhone: '',
        });
      }
    },
    // 刷新省市区下拉选项（回显编码后用于显示名称）
    refreshRegionOptions() {
      ['provinceCode', 'cityCode', 'districtCode'].forEach((field) => {
        this.getRule(field).refresh = true;
      });
      this.getOptins('provinceCode');
      this.getOptins('cityCode');
      this.getOptins('districtCode');
    },
    // 表单渲染完成后的回调
    formComplete() {
      // 按单据类型控制原联系人信息、原地址显示（新增默认隐藏）
      this.setType(this.getFieldValue('type') || '0');
      const isView = this.formConfig.code === 'view';
      // 新地址仅详情展示，其余场景隐藏
      this.hiddenFields(!isView, ['newAddress']);
      if (isView) {
        // 详情不展示省市区、详细地址，用新地址拼接展示
        this.hiddenFields(true, ['provinceCode', 'cityCode', 'districtCode', 'detailedAddress']);
      }
      if (this.formConfig.code === 'edit' || isView) {
        request.post('/mdm/mdmcustomeraddressprocess/query', {
          id: this.formConfig.row.id,
        }).then((res) => {
          if (res.success) {
            this.setValue(res.result);
            // 按单据类型重新控制原联系人信息、原地址显示，并回显原地址
            this.setType(res.result.type);
            if (String(res.result.type) === '1') {
              this.setValue({
                oldAddress: res.result.oldAddress || res.result.originalId || '',
              });
              this.getOptins('oldAddress');
            }
            if (isView) {
              // 新地址 = 新地址省市区+详细地址拼接
              this.setValue({
                newAddress: `${res.result.provinceName || ''}${res.result.cityName || ''}${res.result.districtName || ''}${res.result.detailedAddress || ''}`,
                oldContactName: res.result.originalId ? res.result.originalVo.contactName : '',
                oldContactPhone: res.result.originalId ? res.result.originalVo.contactPhone : '',
              });
            } else {
              // 回显后刷新省市区选项，保证编码正常显示名称
              this.refreshRegionOptions();
            }
          }
        });
      }
    },

    // 提交
    submit() {
      const formData = this.getFormData(); // 获取表单的值
      if (formData) {
        let url = '/mdm/mdmcustomeraddressprocess/save';
        const params = {
          ...formData,
        };
        // 提交不携带原地址显示字段、新地址展示字段，仅保留originalId
        delete params.oldAddress;
        delete params.newAddress;
        if (!params.originalId) {
          delete params.originalId;
        }
        if (this.formConfig.code === 'edit') {
          url = '/mdm/mdmcustomeraddressprocess/update';
          params.id = this.formConfig.row.id;
        }
        request.post(url, params).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
